
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ind/gift-card/step-1",
      function () {
        return require("private-next-pages/ind/gift-card/step-1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ind/gift-card/step-1"])
      });
    }
  